import styled from "styled-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";

export const Modal = styled(ProModal)`
    padding: 20px 24px !important;
    max-width: 550px;
`;
